import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface PageState {
  searchValue?: string;
  path: string;
  title: string;
  showSidebar: boolean;
  sidebarCollapsed: boolean;
  isDynamicTitle?: boolean;
}

const SIDEBAR_COLLAPSED_STORAGE_KEY = 'sidebarCollapsed';

const getInitialSidebarCollapsed = (): boolean => {
  try {
    return localStorage.getItem(SIDEBAR_COLLAPSED_STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
};

export const initialState: PageState = {
  searchValue: '',
  path: '/',
  title: 'Administrators',
  showSidebar: true,
  sidebarCollapsed: getInitialSidebarCollapsed(),
};

const pageSlice = createSlice({
  name: 'page',
  initialState,
  reducers: {
    setPageInfo(state, action: PayloadAction<Omit<PageState, 'sidebarCollapsed'>>) {
      state.path = action.payload.path;
      state.title = action.payload.title;
      state.showSidebar = action.payload.showSidebar;
      state.isDynamicTitle = action.payload.isDynamicTitle;
    },
    setPageSearchValue(state, action: PayloadAction<string>) {
      state.searchValue = action.payload;
    },
    clearPageSearchValue(state) {
      state.searchValue = '';
    },
    toggleSidebarCollapsed(state) {
      state.sidebarCollapsed = !state.sidebarCollapsed;
      try {
        localStorage.setItem(
          SIDEBAR_COLLAPSED_STORAGE_KEY,
          String(state.sidebarCollapsed)
        );
      } catch {
        // ignore storage errors
      }
    },
    setSidebarCollapsed(state, action: PayloadAction<boolean>) {
      state.sidebarCollapsed = action.payload;
      try {
        localStorage.setItem(
          SIDEBAR_COLLAPSED_STORAGE_KEY,
          String(action.payload)
        );
      } catch {
        // ignore storage errors
      }
    },
  },
});

export const {
  setPageInfo,
  setPageSearchValue,
  clearPageSearchValue,
  toggleSidebarCollapsed,
  setSidebarCollapsed,
} = pageSlice.actions;
export default pageSlice.reducer;
